import { Button, DatePicker, Form, Row, Space } from 'antd';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { getGeneralExpenses } from '../../../../appRedux/actions/Reports';
import { buttonLabel, formConfig } from '../../../../constants';

export const GeneralExpensesFilter = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const onSubmit = (values) => {
    if (values?.month) values.month = moment(values?.month).format('YYYY-MM');
    dispatch(getGeneralExpenses(values));
  };

  return (
    <Row>
      <Form {...formConfig} onFinish={onSubmit} form={form}>
        <Space>
          <Form.Item name="month">
            <DatePicker picker="month" format={'YYYY-MM'} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="btn-form" htmlType="submit">
              {buttonLabel.search}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Row>
  );
};
